// Algolia cannot process more than 20 objectIDs in an event
export const cappedObjectIds = (objectIds: string[]) => objectIds.slice(0, 20);
